<template>
  <div id="map-container">
    <div id="popup" class="ol-popup">
      <RentalObjectMap
        v-if="mapLoaded"
        :rentalObject="activeMarker"
        :poi="1"
        :overlayOpen="selectedPoi" />
    </div>
    <div id="map"></div>
  </div>
</template>

<script>
/* eslint-disable */
// import openlayer css for style
import 'ol/ol.css';
// This is library of openlayer for handle map
import Map from 'ol/Map';
import View from 'ol/View';
import Overlay from 'ol/Overlay';
import { fromLonLat } from 'ol/proj';
import Feature from 'ol/Feature';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import { defaults as defaultControls, ScaleLine } from 'ol/control';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import Vector from 'ol/source/Vector.js';
import Cluster from 'ol/source/OSM.js';
import OSM from 'ol/source/OSM.js';
import Point from 'ol/geom/Point';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import { Circle as CircleStyle } from 'ol/style';
import RentalObjectMap from '@/components/search/rentalobjectmap';

export default {
  components: {
    RentalObjectMap,
  },
  props: {
    objecttype: {
      required: true,
      type: String,
      default: 'parking',
    },

    isSingle: {
      type: Boolean,
    },

    single: {
      required: false,
      type: Object,
      default() {
        return {};
      },
    },
    singleLongitude: {
      required: false,
      type: String,
    },

    singleLatitude: {
      required: false,
      type: String,
    },

    markers: {
      required: false,
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      clusterArray: [],
      markerArr: [],
      activeMarker: [],
      centerArr: [17.1561383, 60.6798246],
      mapLoaded: false,
      hoveredPoi: {
        type: Object,
        default: null,
      },
      selectedPoi: {
        type: Object,
        default: null,
      },
      map: null,
      vectorLayer: null,
    };
  },

  computed: {
    id() {
      return '';
    },
  },
  watch: {
    objecttype: function (newVal, oldVal) {
      // watch it
      this.initiateMap();
    },
    markers: function (newVal, oldVal) {
      // watch it
      if (newVal != oldVal) this.initiateMap();
    },
    singleLongitude: function (newVal, oldVal) {
      if (newVal != oldVal) this.initiateMap();
    },
  },
  mounted() {
    if ((this.isSingle && this.singleLongitude) || (!this.isSingle && this.markers))
      this.initiateMap();
  },
  methods: {
    initiateMap() {
      let zIndex = 0;
      this.mapLoaded = true;

      if (this.vectorLayer) {
        this.map.removeLayer(this.vectorLayer);
      }

      var o = this.objecttype;
      if (this.objecttype == 'otherRentalObject') o = 'plant';
      this.selectedPoi = null;
      this.hoveredPoi = null;

      var structuresStyleHover = function (feature) {
        let svgSrc =
          'https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-poi-' +
          o +
          '-select.svg';
        if (feature.get('label').length) {
          svgSrc =
            'https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-poi-' +
            o +
            '-select-multiple.svg';
        }

        let weight = 'bold';
        let size = '12px';
        let height = 1;
        let font = 'arial';

        var style = new Style({
          fill: new Fill({ color: feature.get('shapefill') }),
          stroke: new Stroke({ color: feature.get('shapestroke') }),
          image: new Icon(
            /** @type {olx.style.IconOptions} */ ({
              anchor: [16, 16],
              anchorXUnits: 'pixels',
              anchorYUnits: 'pixels',
              opacity: 1,
              src: svgSrc,
            }),
          ),
          text: new Text({
            offsetX: 26,
            offsetY: 5,
            placement: 'point',
            textAlign: 'center',
            font: weight + ' ' + size + '/' + height + ' ' + font,
            text: feature.get('label'),
            fill: new Fill({
              color: '#000',
            }),
            backgroundFill: new Fill({
              color: '#fff',
            }),
            // padding: [2, 2, 2, 2]
          }),
          zIndex: zIndex++,
        });
        return style;
      };

      var poiStyle = function (feature) {
        let weight = 'bold';
        let size = '12px';
        let height = 1;
        let font = 'arial';
        let svgSrc =
          'https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-poi-' +
          o +
          '.svg';
        if (feature.get('label').length) {
          svgSrc =
            'https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-poi-' +
            o +
            '-multiple.svg';
        }

        let s = [
          new Style({
            image: new Icon(
              /** @type {olx.style.IconOptions} */ ({
                anchor: [16, 16],
                anchorXUnits: 'pixels',
                anchorYUnits: 'pixels',
                opacity: 1,
                src: svgSrc,
              }),
            ),
            text: new Text({
              offsetX: 26,
              offsetY: 5,
              placement: 'point',
              textAlign: 'center',
              font: weight + ' ' + size + '/' + height + ' ' + font,
              text: feature.get('label'),
              fill: new Fill({
                color: '#000',
              }),
              backgroundFill: new Fill({
                color: '#fff',
              }),
            }),
            zIndex: zIndex++,
          }),
        ];

        return s;
      };

      let id = 0;
      let addedMarkerPositions = {};
      let temp = [];
      this.markerArr = [];

      //if it's just a single poi on an object page
      if (this.singleLongitude) {
        this.single.lon = this.singleLongitude;
        this.single.lat = this.singleLatitude;

        this.centerArr = [this.singleLongitude, this.singleLatitude];
        if (!!addedMarkerPositions[this.singleLongitude + '' + this.singleLatitude]) {
          //position already added to map - add to cluster array
          //push to cluster-specific array?
          addedMarkerPositions[this.singleLongitude + '' + this.singleLatitude].push(this.single);
        } else {
          addedMarkerPositions[this.singleLongitude + '' + this.singleLatitude] = [];
          addedMarkerPositions[this.singleLongitude + '' + this.singleLatitude].push(this.single);
          temp.push(this.single);
        }
      }
      //cluster markers on same coordinates
      else if (this.markers.length > 0) {
        this.markers.sort((a, b) => (a.lat > b.lat ? 1 : -1));

        this.markers.forEach((m) => {
          id++;

          m.lon = m.coordinates ? m.coordinates.longitude : 0;
          m.lat = m.coordinates ? m.coordinates.latitude : 0;

          if (!!addedMarkerPositions[m.lon + '' + m.lat]) {
            //position already added to map - add to cluster array
            //push to cluster-specific array?
            addedMarkerPositions[m.lon + '' + m.lat].push(m);
          } else {
            addedMarkerPositions[m.lon + '' + m.lat] = [];
            addedMarkerPositions[m.lon + '' + m.lat].push(m);
            temp.push(m);
          }
        });
      }

      if (temp.length > 0) {
        temp.forEach((m) => {
          let t =
            addedMarkerPositions[m.lon + '' + m.lat].length > 1
              ? addedMarkerPositions[m.lon + '' + m.lat].length
              : '';
          var poi = new Feature({
            geometry: new Point(fromLonLat([m.lon, m.lat])),
            id: m.lon + '' + m.lat,
            markers: addedMarkerPositions[m.lon + '' + m.lat],
            label: t + '',
          });

          poi.setStyle(poiStyle(poi));
          this.markerArr.push(poi);
        });
      }

      var vectorSource = new Vector({
        features: this.markerArr,
      });

      var clusterSource = new Cluster({
        distance: 10,
        source: vectorSource,
      });

      var vectorLayer = (this.vectorLayer = new VectorLayer({
        source: vectorSource,
      }));
      var styleCache = {};
      var clusters = new VectorLayer({
        source: clusterSource,
        style: function (feature) {
          var size = feature.get('features').length;
          var clusterstyle = styleCache[size];
          if (!clusterstyle) {
            clusterstyle = new Style({
              image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                  color: '#fff',
                }),
                fill: new Fill({
                  color: '#3399CC',
                }),
              }),
              text: new Text({
                text: size.toString(),
                fill: new Fill({
                  color: '#fff',
                }),
              }),
            });
            styleCache[size] = clusterstyle;
          }
          return clusterstyle;
        },
      });

      if (!this.map) {
        /**
         * Elements that make up the popup.
         */
        var container = document.getElementById('popup');

        /**
         * Create an overlay to anchor the popup to the map.
         */
        var overlay = new Overlay({
          element: container,
          autoPan: true,
          autoPanMargin: 5,
          autoPanAnimation: {
            duration: 250,
          },
        });

        var map = (this.map = new Map({
          controls: defaultControls().extend([
            new ScaleLine({
              units: 'degrees',
            }),
          ]),
          target: 'map',
          // layers: layers,
          layers: [
            new TileLayer({
              source: new OSM({
                url: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
                maxZoom: 18,
              }),
            }),
            vectorLayer,
            //  clusters
          ],
          overlays: [overlay],
          view: new View({
            center: fromLonLat(this.centerArr),
            maxZoom: 18,
            zoom: this.singleLongitude ? 15 : 13,
          }),
        }));

        var h = this.hoveredPoi;
        map.on('pointermove', (evt) => {
          if (this.hoveredPoi && this.hoveredPoi != this.selectedPoi) {
            this.hoveredPoi.setStyle(poiStyle(this.hoveredPoi));
            this.hoveredPoi = null;
          }

          if (evt.dragging) {
            return;
          }

          var hit = map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
            feature.setStyle(structuresStyleHover(feature));
            return feature;
          });

          this.hoveredPoi = hit;

          if (hit) {
            map.getTargetElement().style.cursor = 'pointer';
          } else {
            map.getTargetElement().style.cursor = '';
          }
        });

        map.on('singleclick', (evt) => {
          var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
            return feature;
          });
          if (feature) {
            if (this.selectedPoi) {
              this.selectedPoi.setStyle(poiStyle(this.selectedPoi));
              this.selectedPoi = null;
            }

            this.activeMarker = feature.get('markers');
            var coordinate = evt.coordinate;
            this.selectedPoi = feature;

            overlay.setPosition(coordinate);
          } else {
            if (this.selectedPoi) {
              this.selectedPoi.setStyle(poiStyle(this.selectedPoi));
              this.selectedPoi = null;
            }
            overlay.setPosition(undefined);
          }
        });
      } else {
        this.map.addLayer(vectorLayer);
      }
    },
  },
};
</script>
<style lang="scss" scoped>

#map {
  position: absolute;
  margin: 0;
  padding: 0;
  height: 500px;
  width: 99%;
}

#map-container {
  font-family: $sansserif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $abgdarkblue;
  min-height: 500px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: $abgdarkblue;
}

#nav a.router-link-exact-active {
  color: $green;
}

.ol-popup {
  box-shadow: 0 0 24px 0 rgba(0, 84, 102, 0.12);
}

#main-content a[href*="https://"]:after, #main-content a[href*="http://"]:after {
  content: "" !important;
}


</style>

<style>
.ol-control button {
  background-color: $abgblue!important;
}

.ol-attribution {
  font-size: 12px;
}


</style>
